import createReducer from 'utils/createReducer';

import {
    SET_FORM_SUBMITTING,
    UPDATE_FORM_VALUE,
    CLEAR_FORM_GROUPS,
    UPDATE_FORM_GROUP_VALUE,
    SET_FORM_GROUP_VALUES,
    UPDATE_FORM_TOUCHED,
    SET_FORM_VALUES,
    SET_FORM_INITIAL_VALUES,
    UPDATE_FORM_INITIAL_VALUE,
    SET_FORM_ERRORS,
    SET_FORM_NODE_ERROR,
    SET_FORM_GROUP_ERRORS,
    SET_FORM_TOUCHED,
    SET_FORM_VISIBILITY,
    SET_FORM_GROUP_VISIBILITY,
    SET_FIELD_ERROR,
    SET_FORM_META,
    SET_FORM_METAS,
    SET_SELECTED_SESSIONS,
    TOGGLE_SELECTED_SESSION,
} from '../constants/actionTypes';

const defaultFormInitialState = {
    allowSubmit: false,
    isSubmitting: false,
    values: {},
    initialValues: {},
    errors: {},
    meta: {},
    touched: {},
    visibility: {},
    sessions: {},
};

const handlers = {
    [SET_FORM_SUBMITTING]: (state, { payload: { isSubmitting } }) => ({
        ...state,
        isSubmitting,
    }),
    [UPDATE_FORM_VALUE]: (state, { payload: { id, value } }) => ({
        ...state,
        values: {
            ...state.values,
            [id]: value,
        },
    }),
    [UPDATE_FORM_INITIAL_VALUE]: (state, { payload: { id, value } }) => ({
        ...state,
        initialValues: {
            ...state.values,
            [id]: value,
        },
    }),
    [UPDATE_FORM_TOUCHED]: (state, { payload: { id, touched } }) => ({
        ...state,
        touched: {
            ...state.touched,
            [id]: touched,
        },
    }),
    [SET_FIELD_ERROR]: (state, { payload: { id, error } }) => ({
        ...state,
        errors: {
            ...state.errors,
            [id]: error,
        },
    }),
    [SET_FORM_META]: (state, { payload: { id, meta } }) => ({
        ...state,
        meta: {
            ...state.meta,
            [id]: meta,
        },
    }),
    [SET_FORM_METAS]: (state, { payload: { meta } }) => ({
        ...state,
        meta: {
            ...meta,
        },
    }),
    [SET_FORM_VALUES]: (state, { payload: { values } }) => ({
        ...state,
        values,
    }),
    [SET_FORM_INITIAL_VALUES]: (state, { payload: { initialValues } }) => ({
        ...state,
        initialValues,
    }),
    [SET_FORM_ERRORS]: (state, { payload: { errors } }) => ({
        ...state,
        errors,
    }),
    [SET_FORM_TOUCHED]: (state, { payload: { touched } }) => ({
        ...state,
        touched,
    }),
    [SET_FORM_VISIBILITY]: (state, { payload: { visibility } }) => ({
        ...state,
        visibility,
    }),
    [SET_SELECTED_SESSIONS]: (state, { payload: { sessions } }) => ({
        ...state,
        sessions,
    }),
    [TOGGLE_SELECTED_SESSION]: (state, { payload: { sessionId } }) => ({
        ...state,
        sessions: {
            ...state.sessions,
            [sessionId]: !(state?.sessions?.[sessionId] ?? false),
        },
    }),
};

const groupsInitialState = {};

const groupHandlers = {
    [CLEAR_FORM_GROUPS]: (state, action) => ({
        default: state.default,
    }),

    [UPDATE_FORM_GROUP_VALUE]: (state, { payload: { id, group, value } }) => ({
        ...state,
        [group]: {
            ...state[group],
            values: {
                ...(state[group] ? state[group].values : {}),
                [id]: value,
            },
        },
    }),

    [SET_FORM_GROUP_VALUES]: (state, { payload: { values, group } }) => ({
        ...state,
        [group]: {
            ...state[group],
            values,
        },
    }),

    [SET_FORM_GROUP_ERRORS]: (state, { payload: { errors, group } }) => ({
        ...state,
        [group]: {
            ...state[group],
            errors,
        },
    }),

    [SET_FORM_NODE_ERROR]: (state, { payload: { errors, group, id } }) => ({
        ...state,
        [group]: {
            ...state[group],
            errors: {
                ...state[group].errors,
                [id]: errors,
            },
        },
    }),

    [SET_FORM_GROUP_VISIBILITY]: (state, { payload: { visibility, group } }) => ({
        ...state,
        [group]: {
            ...state[group],
            visibility,
        },
    }),
};

const defaultReducers = createReducer(defaultFormInitialState, handlers);
const groupsReducers = createReducer(groupsInitialState, groupHandlers);

const initialState = {
    ...groupsInitialState,
    default: defaultFormInitialState,
};

export default (state = initialState, action) => ({
    ...groupsReducers(state, action),
    default: defaultReducers(state.default, action),
});
